import type { DocumentError } from "@packages/commons";

export const applyLocalErrorsToSavedDocument = <TDocument extends { errors?: DocumentError[] }>(
  document: TDocument,
  errors: DocumentError[],
): TDocument => {
  return {
    ...document,
    errors,
  };
};
